// eslint-disable-next-line import/prefer-default-export
export const AVAILABLE_INTERVALS = {
  monthly: { id: 'monthy', label: 'Monthly', defaultRange: 6 },
  weekly: { id: 'weekly', label: 'Weekly', defaultRange: 6 },
  custom: { id: 'custom', label: 'custom' },
}
